var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";
import DatePicker from "./DatePicker";

class DateRange extends Component {
  onChange(prop, propValue) {
    const { value, onChange } = this.props;
    const state = _objectSpread(_objectSpread({}, value), {}, { [prop]: propValue });

    onChange(state);
  }

  render() {
    const { useTimezone, locale, format } = this.props;
    const { value } = this.props;
    const { from: stateFrom, to: stateTo } = value || { from: null, to: null };

    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "DatePicker__From" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "truncate" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Label date \"From\"" }, void 0, "From:")
      ), /*#__PURE__*/
      _jsx(DatePicker, {
        locale: locale,
        format: format,
        useTimezone: useTimezone,
        value: stateFrom,
        onChange: (val) => this.onChange('from', val) }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "DatePicker__To" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "truncate" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Label date \"to\"" }, void 0, "To:")
      ), /*#__PURE__*/
      _jsx(DatePicker, {
        locale: locale,
        format: format,
        useTimezone: useTimezone,
        value: stateTo,
        endOfDay: true,
        onChange: (val) => this.onChange('to', val) }
      )
      )
      ));

  }
}

DateRange.defaultProps = {
  value: { from: null, to: null },
  onChange: () => {},
  locale: undefined,
  format: undefined,
  useTimezone: false
};









export default DateRange;